export type TimelineEventCategory =
  | 'formation'
  | 'chapter'
  | 'workshop'
  | 'assessment'
  | 'message'
  | 'learner'
  | 'activity';

export type TimelineEvent = {
  id: string;
  category: TimelineEventCategory;
  type: string;
  title: string;
  description?: string;
  startAt: string;
  endAt?: string;
  isFuture: boolean;
  payload?: Record<string, unknown>;
};

export type ParcoursViewMode = 'list' | 'calendar' | 'timeline';

export const TIMELINE_CATEGORY_LABELS: Record<TimelineEventCategory, string> = {
  formation: 'Formation',
  chapter: 'Chapitres',
  workshop: 'Ateliers',
  assessment: 'Diagnostic / impact',
  message: 'Messages',
  learner: 'Parcours apprenant',
  activity: 'Activité',
};

export const TIMELINE_CATEGORY_COLORS: Record<
  TimelineEventCategory,
  'primary' | 'secondary' | 'success' | 'warning' | 'info' | 'error' | 'default'
> = {
  formation: 'primary',
  chapter: 'info',
  workshop: 'secondary',
  assessment: 'warning',
  message: 'success',
  learner: 'default',
  activity: 'info',
};

export const TIMELINE_CATEGORY_DOT_COLORS: Record<TimelineEventCategory, string> = {
  formation: '#1976d2',
  chapter: '#0288d1',
  workshop: '#9c27b0',
  assessment: '#ed6c02',
  message: '#2e7d32',
  learner: '#616161',
  activity: '#00838f',
};

export const TIMELINE_CATEGORY_SHORT_LABELS: Record<TimelineEventCategory, string> = {
  formation: 'Formation',
  chapter: 'Chapitre',
  workshop: 'Atelier',
  assessment: 'Impact',
  message: 'Message',
  learner: 'Parcours',
  activity: 'Activité',
};

export const dayKeyParis = (iso: string): string => {
  const date = new Date(iso);
  return date.toLocaleDateString('en-CA', { timeZone: 'Europe/Paris' });
};

export const formatTimelineDateTime = (iso: string): string =>
  new Date(iso).toLocaleString('fr-FR', {
    timeZone: 'Europe/Paris',
    dateStyle: 'medium',
    timeStyle: 'short',
  });

export const formatTimelineDate = (iso: string): string =>
  new Date(iso).toLocaleDateString('fr-FR', {
    timeZone: 'Europe/Paris',
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

/** Jour + mois court pour les ronds de la timeline (sans heure). */
export const formatTimelineCircleDate = (iso: string): { day: string; month: string } => {
  const date = new Date(iso);
  return {
    day: date.toLocaleDateString('fr-FR', {
      timeZone: 'Europe/Paris',
      day: 'numeric',
    }),
    month: date
      .toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris', month: 'short' })
      .replace(/\.$/, ''),
  };
};

export const filterTimelineEvents = (
  events: TimelineEvent[],
  categories: Set<TimelineEventCategory>
): TimelineEvent[] => {
  if (categories.size === 0) return events;
  return events.filter((event) => categories.has(event.category));
};
